export default {
  fi: {
    backButton: "takaisin",
    attention: "Huomioitavaa",
    infotext:
      "Tarkista sähköisesti allekirjoitetut dokumentit nopeasti ja helposti.",
    chooseFile: "Valitse tiedosto tai pudota tiedosto.",
    dragFile: "Pudota tiedosto tähän.",
    selectFile: "Valitse tarkistettava tiedosto",
    fileSelected: "Tiedosto valittu. Voit nyt tarkistaa tiedoston.",
    validationStarted: "Tarkistus aloitettu. Odota hetki.",
    validationComplete: "Tarkistus valmis. Tulokset näytetään.",
    validationError: "Virhe tarkistuksessa. Yritä uudelleen.",
    dataCollectingInfo:
      "On tärkeää huomioida, että palvelumme ei tallenna tai kerää tarkastettavan dokumentin tietoja millään tavalla. Tämä tarkoittaa, että voit käyttää palveluamme turvallisesti ja luottaa siihen, että tietosi pysyvät täysin yksityisinä. Olemme sitoutuneet varmistamaan asiakkaidemme yksityisyyden ja tietoturvan, ja teemme kaikkemme suojellaksemme asiakkaidemme tietoja mahdollisimman hyvin. Voit siis käyttää palveluamme huoletta ja luottaa siihen, että tietosi ovat turvassa.",
    readMore: "Lue lisää tietosuojasta.",
    validateFile: "Tarkista tiedosto",
    languageInfo: "Suomeksi",
    eidas:
      "Hyväksytty allekirjoitus (eIDAS 910/2014 - QESig), joiden varmenteen myöntäjä on EU-hyväksytty ja joiden avainta säilytetään hyväksytyssä turvalaitteessa (QSCD).",

    signedBy: "Allekirjoittanut",
    signedByUnknown: "Tuntematon allekirjoittaja",
    signatureIsValid: "Tiedoston allekirjoitus on oikea",
    signatureIsNotValid: "Tiedoston allekirjoitus ei kelpaa",

    documentNotModified:
      "Dokumenttia ei ole muutettu allekirjoituksen lisäämisen jälkeen.",
    documentModified:
      "Dokumenttia on muutettu allekirjoituksen lisäämisen jälkeen.",
    identityValid: "Allekirjoittajan henkilöllisyys kelpaa.",
    identityNotValid: "Allekirjoittajan henkilöllisyys ei kelpaa",
    signatureForTest: "Allekirjoitus on tarkoitettu testikäyttöön.",
    detailedInformation: "Tarkemmat tiedot",
    signatureValidAndBy: "Allekirjoitus on kelvollinen ja sen on tehnyt",
    signatureTime: "Allekirjoituksen aika",
    documentFromTrustedSource:
      "Dokumentti on peräisin luotettavasta lähteestä, jonka on varmentanut",
    validateAnotherFile: "Tarkista uusi tiedosto",

    close: "Sulje",
    privacyPolicy: "Tietosuojaseloste",
    privacyPolicyText:
      "<h3>Tietosuojakäytäntö</h3>" +
      "<p>Kerätty tieto on luonteeltaan anonyymiä. Palvelu ei kerää henkilötietoja eikä siten muodosta henkilörekisteriä. Palvelu ei tallenna tarkistettuja tiedostoja. Palvelu ei myöskään tallenna tietoja, mitä tarkistetut dokumentit sisältävät pl. dokumentin allekirjoittajan organisaation nimi ja allekirjoituksen kellonaika. Tämä tieto kerätään sähköisestä allekirjoituksesta vain siinä tapauksessa, että sähköinen allekirjoitus on tehty Atomi-allekirjoituspalvelun avulla.</p>" +
      "<h3>Mitä tietoja keräämme ja mistä lähteistä?</h3>" +
      "<p>Palveluiden käytöstä kerätään seuraavia tietoja:<ul>" +
      "<li>Palvelun käyttäjän osittainen IP-osoite, kun käyttäjä tarkistaa dokumentin aitouden palvelun avulla. Osoitetta ei tallenneta kokonaan, joten sitä ei voida yhdistää suoraan käyttäjään. Osittainen IP-osoite (kolme ensimmäistä oktettia IPv4 tai 48 ensimmäistä bittiä IPv6) kerätään, jotta saadaan tietoa siitä, mistä maantieteellisestä sijainnista tarkistuksia tehdään.</li>" +
      "<li>Dokumentin allekirjoituksen tehneen organisaation nimen, mikäli allekirjoituksen tehnyt organisaatio on Atomi-palvelun käyttäjä.</li>" +
      "<li>Allekirjoituksen ajankohta.</li>" +
      "</ul></p>" +
      "<h3>Mihin käyttötarkoitukseen tietoja kerätään?</h3>" +
      "<h4>Palveluiden kehittäminen</h4>" +
      "<p>Studyo Oy hyödyntää kerättyä tietoa palvelun tavoitettavuuden ja kävijämäärien tilastollisessa seurannassa. Tietojen keräämisen tarkoituksena on analysoida ja kehittää palveluita edelleen asiakkaita paremmin palveleviksi. Tietoa käytetään myös parantamaan käyttökokemusta.</p>" +
      "<h4>Markkinointi ja asiakasviestintä</h4>" +
      "<p>Tietoja voidaan käyttää Studyo Oy:n palveluista tiedottamiseen ja informoimiseen. Voimme esimerkiksi olla lokaatiossa oleviin organisaatioihin yhteydessä, joissa dokumentin tarkistusta on tehty.</p>" +
      "<h4>Tilastointiin Atomi-allekirjoituspalvelua käyttäville organisaatioille</h4>" +
      "<p>Tietoja voidaan käyttää ja edelleen luovuttaa Atomi-allekirjoituspalvelua käyttävien asiakasorganisaatioiden käyttöön tilastollista analysointia varten.</p>" +
      "<p>Kerättyä tietoa Studyo Oy käyttää vain yllä esitettyyn kolmeen tarkoitukseen eikä niiden avulla saatua tietoa yhdistetä muihin tietoihin.</p>"
  },
  en: {
    backButton: "back",
    attention: "Attention",
    infotext: "Validate electronically signed documents quickly and easily.",
    chooseFile: "Choose file or drag and drop it here.",
    dragFile: "Drag and drop file here.",
    selectFile: "Select file to validate",
    fileSelected: "File selected. You can now validate the file.",
    validationStarted: "Validation started. Please wait.",
    validationComplete: "Validation complete. Results are displayed.",
    validationError: "Error during validation. Please try again.",
    dataCollectingInfo:
      "Service does not collect any information from validated files.",
    readMore: "Read more about privacy policy.",
    validateFile: "Validate file",
    languageInfo: "In English",
    eidas:
      "Qualified signature (eIDAS 910/2014 - QESig) with EU qualified certificate issuers and signature keys stored in a qualified signature creation device (QSCD).",

    signedBy: "Signed by",
    signedByUnknown: "Signatory unknown",
    signatureIsValid: "Signature of file is valid",
    signatureIsNotValid: "Signature is not valid",

    documentNotModified:
      "The document has not been changed since the signature was added.",
    documentModified:
      "The document has been changed since the signature was added.",
    identityValid: "The signatory's identity is valid.",
    identityNotValid: "The signatory's identity is not valid.",
    signatureForTest: "The signature is intended for test use.",
    detailedInformation: "Detailed information",
    signatureValidAndBy: "The signature is valid and has been made by",
    signatureTime: "Signature time",
    documentFromTrustedSource:
      "The document comes from a trusted source that has been certified by",
    validateAnotherFile: "Validate new file",

    close: "Close",
    privacyPolicy: "Privacy Policy",
    privacyPolicyText:
      "We don't save any information from pdf document that is validated. From validation process we save ip-address, time and organisation that has signed the document.",
    privacyPolicyText:
      "<h3>Privacy Policy</h3>" +
      "<p>The information collected is anonymous in nature. The service does not collect any personal information. The service does not save the files verified in the service. Also, the service does not store what the revised documents contain eg. the name of the signatory organization and the time of the signature. This information is collected from the electronic signature only if the electronic signature is made using the Atomic Signature Service.</p>" +
      "<h3>What information do we collect and from which sources?</h3>" +
      "<p>The following information will be collected on the use of the services:<ul>" +
      "<li>The partial IP address of the service user when the user verifies the document by authentication. The address is not fully saved and cannot be directly linked to the user. The partial IP address (the first three octets of IPv4 or the first 48 bits of IPv6) is collected to provide information on the geographic location of the checks.</li>" +
      "<li>The name of the organization that signed the document if the signing organization is a user of the Atom service.</li>" +
      "<li>Date and time of signature.</li>" +
      "</ul></p>" +
      "<h3>What is the purpose for which the data is collected?</h3>" +
      "<h4>Service development</h4>" +
      "<p>Studyo Oy utilizes the information gathered in statistical monitoring of the availability of the service and the number of visitors. The purpose of data gathering is to analyze and further develop services to better serve customers. The information is also used to improve the user experience.</p>" +
      "<h4>Marketing and customer communication</h4>" +
      "<p>Information can be used to inform and inform Studyo Oy's services. For example, we may contact organizations in a location where a document review has been made.</p>" +
      "<h4>For organizations using Atomic Signature Services</h4>" +
      "<p>The data can be used and further provided for use by customer organizations using the Atomic Signature Service for statistical analysis.</p>" +
      "<p>Studyo Ltd uses the data only for these three purposes and does not combine the information obtained with other data.</p>"
  },
  sv: {
    backButton: "back",
    attention: "Observera",
    infotext:
      "Verifiera elektroniskt undertecknade dokument enkelt och snabbt.",
    chooseFile: "Välj fil eller dra den hit",
    dragFile: "Dra filen hit.",
    selectFile: "Välj fil att verifiera",
    fileSelected: "Fil vald. Du kan nu verifiera filen.",
    validationStarted: "Verifiering påbörjad. Vänligen vänta.",
    validationComplete: "Verifiering klar. Resultat visas.",
    validationError: "Fel vid verifiering. Försök igen.",
    dataCollectingInfo: `Det är viktigt att notera att vår tjänst inte lagrar eller samlar in informationen i dokumentet som
ska granskas på något sätt. Det betyder att du kan använda vår tjänst på ett säkert sätt och lita
på att din information förblir helt privat. Vi är fast beslutna att säkerställa våra kunders integritet
och säkerhet, och vi gör allt vi kan för att skydda våra kunders data så mycket som möjligt. Så du
kan använda vår tjänst utan bekymmer och lita på att din data är säker.`,
    readMore: "Läs mer om dataskyddet.",
    validateFile: "Verifiera dokument",
    languageInfo: "På svenska",
    eidas:
      "Kvalificerad signature (eIDAS 910/2014 - QESig), vars certifikatutfärdare är EU-kvalificerad och vars signaturnyckel är lagrad i en kvalificerad signaturskapande enhet (QSCD).",

    signedBy: "Undertecknad av",
    signedByUnknown: "Okänd undertecknare",
    signatureIsValid: "Dokumentets underskrift är giltig",
    signatureIsNotValid: "Dokumentets underskrift duger inte",

    documentNotModified: "Dokumentet har inte blivit ändrat efter underskrift.",
    documentModified: "Dokumentet har blivit ändrat efter underskrift.",
    identityValid: "Undertecknarens identitet är giltig.",
    identityNotValid: "Undertecknares identitet duger inte.",
    signatureForTest: "Underskriften är ämnad för testning av tjänsten.",
    detailedInformation: "Närmare information",
    signatureValidAndBy: "Underskriften är giltig och tecknad av",
    signatureTime: "Tid för underskrift",
    documentFromTrustedSource:
      "Dokumentet kommer från en säker källa, vilket har verifierats med",
    validateAnotherFile: "Kontrollera nytt dokument",

    close: "Stäng",
    privacyPolicy: "Dataskyddsbeskrivning",
    privacyPolicyText:
      "<h3>Dataskyddspolicy</h3>" +
      "<p>Informationen som samlas är till sin karaktär anonym. Tjänsten samlar inte in personuppgifter och utgör därmed inte ett personregister. Tjänsten lagrar inte de dokument som kontrolleras. Tjänsten lagrar inte heller uppgifter som de kontrollerade dokumenten innehåller, med undantag av namnet på den organisation som undertecknaren representerar och tid för underskrift. Dessa uppgifter om elektronisk underskrift samlas in enbart om den elektroniska underskriften har gjorts med Atomi-tjänsten för underskrifter.</p>" +
      "<h3>Vilka uppgifter samlar vi och från vilka källor?</h3>" +
      "<p>För användning av tjänsten samlas följande uppgifter:<ul>" +
      "<li>Del av användarens IP-adress då användaren verifierar äktheten av ett dokument med hjälp av tjänsten. Adressen lagras inte helt, vilket innebär att det inte kan kopplas direkt till en person. Del av IP-adress (tre första oktetter IPv4 eller 48 första bitar IPv6) samlas in för information om från vilka geografiska platser kontroller görs.</li>" +
      "<li>Namn på den organisation som undertecknaren representerar, ifall organisationen använder Atomi-tjänsten.</li>" +
      "<li>Tid för underskrift.</li>" +
      "</ul></p>" +
      "<h3>För vilket ändamål samlas uppgifter?</h3>" +
      "<h4>Utveckling av tjänster</h4>" +
      "<p>Studyo Oy utnyttjar de insamlade uppgifterna för att statistiskt följa upp tjänstens nåbarhet och antalet användare. Syftet med att samla uppgifter är att analysera och ytterligare utveckla tjänsterna för att bättre betjäna kunderna. Uppgifterna används också för att förbättra användarupplevelsen.</p>" +
      "<h4>Marknadsföring och kommunikation med kund</h4>" +
      "<p>Uppgifter kan användas för att informera om Studyo Oy:s tjänster. Vi kan t.ex. kontakta organisationer som befinner sig på de platser därifrån dokument har kontrollerats.</p>" +
      "<h4>För statistikföring för de organisationer som använder Atomi-tjänster för underskrifter</h4>" +
      "<p>Uppgifterna kan användas och överlåtas till de kundorganisationer som använder Atomi-tjänsten för underskrifter för att analyseras statistiskt.</p>" +
      "<p>Studyo Oy använder insamlade uppgifter enbart för de tre ändamål som presenteras ovan, och uppgifter från dessa kombineras inte med andra uppgifter.</p>"
  }
};
